<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ID'), sort: 'ID' },
                { title: $t('OrderId'), sort: 'OrderId' },
                { title: $t('Amount'), sort: 'Amount' },
                { title: $t('IsTransferred'), sort: 'IsTransferred' },
                { title: $t('ReferenceNo'), sort: 'ReferenceNo' },
                { title: $t('CreationDate'), sort: 'CreationDate' }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width:16%">
                  {{ row.id }}
                </td>
                <td style="width:16%">
                  {{ row.orderId }}
                </td>
                <td style="width:17%">
                  {{ row.amount }}
                </td>
                <td style="width:16%">
                  <span v-if="row.isTransferred == true">{{ $t("Yes") }}</span>
                  <span v-if="row.isTransferred == false">{{ $t("No") }}</span>
                </td>
                <td style="width:16%">
                  {{ row.referenceNo }}
                </td>
                <td style="width:16%">
                  {{ row.creationTime }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  components: {
    DataGrid
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "MiddlewareOfAccessToTadbir/api/ReceiptsQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  }
};
</script>
